import { useEffect, useState } from 'react';

import { FEATURE_FLAGS } from '../common/context/FlagsContext';
import { useFeatureFlagsValue } from '../common/context/FlagsValueContext';

export function useIdxApiEnabled() {
  const [idxApiEnabled, setIdxApiEnabled] = useState(false);
  const flagsContext = useFeatureFlagsValue();
  useEffect(() => {
    const enabled =
      flagsContext?.flags?.find(v => v?.flagKey === FEATURE_FLAGS.OKTA_IDX_API.toString())?.flagValue ?? false;
    setIdxApiEnabled(enabled);
  }, [flagsContext]);

  return idxApiEnabled;
}
